import React, { Component } from 'react';
import { Button } from 'react-materialize';
import AuthService from '../services/AuthService';
import './CadastraEmpresa.css';

class CadastraEmpresa extends Component{
	state = {
		nome: '',
		cnpj: '',
		Auth: new AuthService(),
		pagina: 0,
		nomeAdmin: '',
		email: '',
		senha: ''
	}

	registra = () => {
		const {nome, cnpj, Auth, email, senha, nomeAdmin} = this.state;
		Auth.cadastraEmpresa(nome, cnpj, email, senha, nomeAdmin);
	}

	render(){
		const {cnpj, nome, pagina, nomeAdmin, email, senha} = this.state;
		return (
			<div className="Cadastro">
					{/*empresa*/}
					{pagina === 0 &&
						<div>
							<p className='titulo'>Cadastro da empresa</p>
							<input type='text' placeholder="Nome" value={nome} onChange={(e) => this.setState({nome: e.target.value})} />
							<input type='text' placeholder="CNPJ" value={cnpj} onChange={(e) => this.setState({cnpj: e.target.value})} />
							<Button onClick={() => this.setState({pagina: 1}) } >Proxima Pagina</Button>
						</div>
					}
					{/*admin*/}
					{pagina === 1 &&
						<div>
							<p className='titulo'>Cadastro do Administrador</p>
							<input type='text' placeholder="Administrador" value={nomeAdmin} onChange={(e) => this.setState({nomeAdmin: e.target.value})} />
							<input type='text' placeholder="email" value={email} onChange={(e) => this.setState({email: e.target.value})} />
							<input type='password' placeholder="senha" value={senha} onChange={(e) => this.setState({senha: e.target.value})} />
							<Button onClick={() => this.setState({pagina: 0}) } >Pagina Anterior</Button>
							<Button onClick={() => this.registra() } >Cadastrar</Button>	
						</div>
					}
			</div>
		)
	}
}

export default CadastraEmpresa


// WEBPACK FOOTER //
// ./src/components/CadastraEmpresa.js